import { DataCache } from '../DataCache';
import { AccountSeal } from './AccountEnums';
import { InstrumentTypesColor, getInstrumentTypeShortName } from '@shared/utils/Instruments/InstrumentTypes';
import { Resources } from '@shared/localizations/Resources';
class AccountUtilsClass {
    getAccountsList() {
        const accountList = new Array();
        const accounts = DataCache.getAccounts();
        for (const accId in accounts) {
            accountList.push(accounts[accId]);
        }
        return accountList;
    }
    getSortedAccountList() {
        const accounts = this.getAccountsList();
        return accounts.sort((a, b) => {
            return String.CompareOrdinal(a.FullAccString, b.FullAccString);
        });
    }
    GetAccountModeText(account) {
        switch (account.AccountMode) {
            case AccountSeal.Demo:
                return Resources.getResource('Accounts.AccountDetails.Mode.Demo');
            case AccountSeal.Live:
                return Resources.getResource('Accounts.AccountDetails.Mode.Live');
            case AccountSeal.Contest:
                return Resources.getResource('Accounts.AccountDetails.Mode.Contest');
            case AccountSeal.Funded:
                return Resources.getResource('Accounts.AccountDetails.Mode.Funded');
            case AccountSeal.Challenge:
                return Resources.getResource('Accounts.AccountDetails.Mode.Challenge');
        }
        return Resources.getResource('Accounts.AccountDetails.Mode.Demo');
    }
    GetAccountModeStyle(account) {
        switch (account.AccountMode) {
            case AccountSeal.Demo:
                return 'Demo';
            case AccountSeal.Live:
                return 'Live';
            case AccountSeal.Contest:
                return 'Contest';
            case AccountSeal.Funded:
                return 'Funded';
            case AccountSeal.Challenge:
                return 'Challenge';
            default:
                return 'Demo';
        }
    }
    GetAccountModeWidth(account) {
        switch (account.AccountMode) {
            case AccountSeal.Demo:
            case AccountSeal.Live:
                return 32;
            case AccountSeal.Contest:
                return 39;
            case AccountSeal.Funded:
                return 37;
            case AccountSeal.Challenge:
                return 49;
            default:
                return 32;
        }
    }
    getInsTypeShortName(account) {
        return getInstrumentTypeShortName(account.PreferredInstrumentType);
    }
    getInstrumentColor(account) {
        return InstrumentTypesColor[account.PreferredInstrumentType];
    }
    needAddType(account) {
        return account.PreferredInstrumentType !== -1;
    }
}
export const AccountUtils = new AccountUtilsClass();
